/**
 *  @class
 *  @function ProductTabs
 *
 *  Horizontal tab group used for the product page's Description / Features /
 *  Size guide rows (and any other consecutive "collapsible_tab" blocks).
 */
if (!customElements.get('product-tabs')) {
  class ProductTabs extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll(':scope > .product-tabs__nav > .product-tabs__tab'));
      this.panels = Array.from(this.querySelectorAll(':scope > .product-tabs__panel'));

      this.buttons.forEach((button, index) => {
        button.addEventListener('click', () => this.selectTab(index));
      });

      if (window.Shopify && Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.buttons.indexOf(event.target);
          if (index > -1) this.selectTab(index);
        });
      }
    }

    selectTab(index) {
      this.buttons.forEach((button, i) => {
        const isActive = i === index;
        button.classList.toggle('active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      this.panels.forEach((panel, i) => {
        panel.classList.toggle('active', i === index);
      });
    }
  }
  customElements.define('product-tabs', ProductTabs);
}
